<style lang="scss" scoped>


</style>

<template>
    <input ref="inputField" type="text" v-on:blur="focusOut" :placeholder="placeholder" class="form-control" :disabled="disabled">
</template>

<script>

import { IMask } from 'vue-imask';

export default {
    name: 'RangeSliderInput',
    components: {

    },    
    props: {
        value: {
            type: Number,
            default: null
        },
        imaskOptions: {
            type: Object,
            default: function () { return {} }
        },
        placeholder: {
            type: String,
            default: ''
        },
        digits: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        },
        focus: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            mask: undefined,
            complete: false
        }
    },
    methods: {
        valueToValueInput: function (value) {
            return value ? String(parseFloat(value).toFixed(this.digits)).replace('.',',') : '';
        },
        valueInputToValue: function (valueInput) {
            valueInput = valueInput.trim().replace(',','.');
            return (valueInput.replace('.','') === '') ? null: parseFloat(valueInput);
        },
        focusOut: function () {
            let value = this.valueInputToValue(this.mask.unmaskedValue);
            let valueInput = this.valueToValueInput(value);       
            this.mask.value =  valueInput;
            
            this.updateValue();
            this.$emit('focusOut', true);
        },
        setFocus: function () {
            this.$refs.inputField.focus();
        },
        updateValue: function () {
            let value = this.valueInputToValue(this.mask.unmaskedValue);
            this.$emit('update:value', value);
        }
    },
    watch: {
        value: function (new_value, old_value) {
            if ( new_value !== old_value ) {
                this.mask.value = this.valueToValueInput(this.value);
            }
        },
        focus: function (new_value) {
            if ( new_value === true) {
                this.setFocus();
            }
        }
    },
    mounted: function () {
        let self = this;
        
        this.mask  = IMask(
            this.$refs.inputField, 
            this.imaskOptions
        );
        
        this.mask.on("complete", function () {
            self.updateValue();
        });
        
        this.mask.on("accept", function () {

        });
        
        this.mask.value = this.valueToValueInput(this.value);       
        
        if (this.focus === true) {
            this.setFocus();    
        }
    }
}
</script>